import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

const Percentage = ({
  timeWindowFrameDays,
  timeWindowFrameHours,
  refundPercentage,
  departure,
  arrival,
  openTicket,
  translations
}) => {

  const isHours = timeWindowFrameHours !== '0';
  const isOpenTicket = openTicket === '1';
  const HasPortOfDeparture = departure.length > 0;
  const HasPortOfArrival = arrival.length > 0;
  const {cancelPolicyDays, cancelPolicyHours, cancelPolicyPort,
    cancelPolicyArrivalPort, cancelPolicyTicket} = translations;

  return (
    <li>
      {
        `${isHours ? cancelPolicyHours : cancelPolicyDays}
          ${isOpenTicket ? cancelPolicyTicket : ''}
          ${HasPortOfDeparture ? cancelPolicyPort : ''}
          ${HasPortOfArrival ? cancelPolicyArrivalPort : ''}`
          .replace('{time}', isHours ? timeWindowFrameHours : timeWindowFrameDays)
          .replace('{refund}', `${refundPercentage}%`)
          .replace('{portDeparture}', departure.join(', '))
          .replace('{portArrival}', arrival.join(', '))
      }
    </li>
  );
};

Percentage.defaultProps = {
  arrival: []
};

Percentage.propTypes = {
  timeWindowFrameDays: PropTypes.string.isRequired,
  timeWindowFrameHours: PropTypes.string.isRequired,
  refundPercentage: PropTypes.string.isRequired,
  departure: PropTypes.object.isRequired,
  arrival: PropTypes.object.isRequired,
  openTicket: PropTypes.string.isRequired,
  translations: PropTypes.shape({
    cancelPolicyDays: PropTypes.string.isRequired,
    cancelPolicyHours: PropTypes.string.isRequired,
    cancelPolicyPort: PropTypes.string.isRequired,
    cancelPolicyTicket: PropTypes.string.isRequired,
    cancelPolicyArrivalPort: PropTypes.string.isRequired
  }).isRequired
};

export default observer(Percentage);
